import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import type { RouteContext } from '@townsquare/router/routing-types';
import { teamsDirectoryRoute } from '@townsquare/routes/teams-directory-view';
import { tqlExplainerTeamAggResource } from '@townsquare/tql/agg/resource/team-explainer';

import { cleanUpTeamsSkillNudgeResource } from './resources/clean-up-teams-skill-nudge';
import { teamDirectoryResource } from './resources/team-directory';
import { teamDirectoryTableResource } from './resources/team-directory-table';

const TeamsDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "teams-directory-view" */ './AggTeamDirectory'),
	loading: () => null,
});

teamsDirectoryRoute.component = TeamsDirectoryLoadable;
teamsDirectoryRoute.relayEnvironment = 'agg';
teamsDirectoryRoute.resources = [
	teamDirectoryResource,
	teamDirectoryTableResource,
	tqlExplainerTeamAggResource,
	cleanUpTeamsSkillNudgeResource,
];

export const teamsDirectoryRouterRoute: GlobalHomePageRoute = teamsDirectoryRoute;
